module.exports = __webpack_public_path__ + "img/schnittkante_tieforange_ral2011.8d51df80.jpg";